import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogConfirmWithReasonData {
  msg: string;
  reasonLabel?: string;
  reasonPlaceholder?: string;
  confirmText: string;
  cancelText: string;
}

export interface DialogConfirmWithReasonResult {
  confirmed: boolean;
  reason: string;
}

@Component({
  selector: 'app-dialog-confirm-with-reason',
  templateUrl: './dialog-confirm-with-reason.component.html',
  styleUrls: ['./dialog-confirm-with-reason.component.scss']
})
export class DialogConfirmWithReasonComponent {
  reason: string = '';

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmWithReasonComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfirmWithReasonData
  ) {}

  get reasonLabel(): string {
    return this.data.reasonLabel || 'Motivo';
  }

  get reasonPlaceholder(): string {
    return this.data.reasonPlaceholder || 'Ingrese el motivo...';
  }

  confirm(): void {
    if (!this.reason || !this.reason.trim()) {
      return;
    }
    this.dialogRef.close({ confirmed: true, reason: this.reason.trim() } as DialogConfirmWithReasonResult);
  }

  cancel(): void {
    this.dialogRef.close({ confirmed: false, reason: '' } as DialogConfirmWithReasonResult);
  }

  get canConfirm(): boolean {
    return !!this.reason && this.reason.trim().length > 0;
  }
}
